// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__196T9","clinicsSelect":"TableHeading_clinicsSelect__TuxOl"};